import React, { Component } from 'react';
import Radium, { Style } from 'radium';

const UpsertTableStyles = (props) => (
  <Style
    rules={{
      '.edit-icon-hover': {
        cursor: 'pointer'
      },
      '.edit-icon-hover:hover': {
        color: 'blue'
      },
      '.trash-icon-hover': {
        cursor: 'pointer',
        color: 'red'
      },
      '.trash-icon-hover:hover': {
        color: 'orange'
      }
    }} />
);

export default UpsertTableStyles;


// WEBPACK FOOTER //
// ./src/components/styles/UpsertTableStyles.jsx